module.exports = __webpack_public_path__ + "img/7_23.f7069827.png";